const coreuiIcons = require('@coreui/icons')
import { logo } from './logo'

export const iconsSet = Object.assign(
  {},
  { logo },
  { ...coreuiIcons }
)
